import React from "react";
import { ApolloErrorGuard } from "../../../shared/ApolloErrorGuard/ApolloErrorGuard";
import { ProductsList } from "../../../ProductsList/ProductsList";
import { useQuery } from "react-apollo";
import { getOnSaleProducts } from "../../../../queries/home";

export const OnSale = () => {
  const { loading, error, data } = useQuery(getOnSaleProducts);

  const products = data?.products?.nodes || [];

  return (
    <div className="OnSale animate__animated animate__fadeIn">
      <ApolloErrorGuard error={error}>
        <ProductsList
          loadingPlaceholderNumber={8}
          loading={loading}
          error={error?.message}
          products={products}
          isLoading={false}
          pageInfo={false}
          onLoadMore={() => {}}
        />
      </ApolloErrorGuard>
    </div>
  );
};
